import { NgModule } from "@angular/core";
import { AskGeoResultComponent } from "./ask-geo-result/ask-geo-result.component";
import { AskGeoRoutingModule } from "./ask-geo-routing.module";
import { MatButtonModule } from "@angular/material/button";
import { FormsModule } from "@angular/forms";
import { MatInputModule } from "@angular/material/input";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatTableModule } from "@angular/material/table";
import { CommonModule } from "@angular/common";
import { MatIconModule } from "@angular/material/icon";

@NgModule({
  declarations: [
    AskGeoResultComponent
  ],
  imports: [
    AskGeoRoutingModule,
    CommonModule,
    MatTableModule,
    MatCheckboxModule,
    MatInputModule,
    FormsModule,
    MatButtonModule,
    MatIconModule,
  ]
})
export class AskGeoModule { }
